export const GET_LABELS = "GET_LABELS";
export const SET_PRINTERS = 'SET_PRINTERS'